import Iframe from './iframe';
export { Iframe };
export default Iframe;